module.exports = __webpack_public_path__ + "static/img/jigou-henanzhongyuan-bottom.bb6201d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/jigou/jigou-henanzhongyuan-bottom.png
// module id = +IqY
// module chunks = 2